import { PreferredTimeValue, PropertyType } from '@/types';
import { HgSupportedLanguage } from '@smg-real-estate/domus';
import { Source } from '@smg-real-estate/seller-leads-schema';

export enum ContactRequestPurpose {
  AGENCY_RECOMMENDATION = 'agency_recommendation',
  CALL_ME_BACK = 'call_me_back',
}

export interface ContactRequest {
  phoneNumber: string;
  firstName: string;
  lastName: string;
  preferredDay: string;
  preferredTime: PreferredTimeValue[];
  language: HgSupportedLanguage;
  purpose: ContactRequestPurpose;
  message?: string;
  propertyDetails?: PropertyDetail;
}

export interface PropertyDetail {
  id?: string;
  name?: string;
  address: string;
  phone?: string;
  phoneVerified?: boolean;
  email?: string;
  livingSpace: number;
  priceFixed: number;
  priceFrom: number;
  priceTo: number;
  rooms: number;
  lotSize?: number;
  type: PropertyType;
  yearBuild: number;
  timeOfSale?: TimeOfSale;
  renovationYear?: number;
  estimationReason?: string;
  confirm_free_consultation?: boolean;
  interested_in_hiring_real_estate_agent?: boolean;
  source: Source;
  isPropertyOwner?: boolean;
}

export enum TimeOfSale {
  asap = 'asap',
  within_6_months = 'within_6_months',
  within_2_years = 'within_2_years',
  in_2_years = 'in_2_years',
}
